export default "__VITE_ASSET__BjE4no_C__"